import * as React from 'react';
import {statusLabel, AvailabilityStatus} from 'Src/helpers/service/adminSU/highLevelTournament';
import './TournamentAvailabilityIcon.scss';

export const tournamentAvailabilityOptions = ['AVAILABLE', 'NOT_AVAILABLE', 'PENDING', 'UNREQUESTED'].map(value => ({value, text: value === 'UNREQUESTED' ? 'Not requested' : statusLabel(value as AvailabilityStatus)}));
export function playerAvailabilityStatus(player: any): string {
  return player.tournamentAvailability && (player.availabilityRequested || player.tournamentAvailability !== 'PENDING') ? player.tournamentAvailability : 'UNREQUESTED';
}
export function TournamentAvailabilityIcon({player}: {player: any}) {
  const status = playerAvailabilityStatus(player);
  const label = tournamentAvailabilityOptions.find(option => option.value === status)?.text || 'Not requested';
  return <span className={`tournamentAvailabilityIcon tournamentAvailabilityIcon--${status}`} role="img" aria-label={label} title={label}>
    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" />{status === 'AVAILABLE' ? <path d="m7.5 12 3 3 6-6" /> : status === 'NOT_AVAILABLE' ? <path d="m8.5 8.5 7 7m0-7-7 7" /> : status === 'PENDING' ? <path d="M12 7v5l3 2" /> : <path d="M8 12h8" />}</svg>
  </span>;
}
